// SearchTitle.js
import React from 'react';
import { useDispatch } from 'react-redux';
import {setSearchTerm, setDashBoardIsActive} from "../../../Features/Misc/activeSlice";
import {setWatchIsActive} from "../../../Features/Misc/navBarSlice";
import BackToLandingButton from "../../Components/BackToLandingButton";
import ExploreEverythingButton from "../../Components/ExploreEverythingButton";

const SearchTitle = ({ searchQuery  }) => {
    // const dispatch = useDispatch();

    // const handleBackClick = () => {
    //     dispatch(setWatchIsActive())
    //     dispatch(setDashBoardIsActive());
    //     dispatch(setSearchTerm(''));
    // };

    return (
        <div className="flex justify-between items-center">
            <h1 className="text-white lg:text-2xl">
                Search results for <strong className="text-2xl block lg:inline-block">{searchQuery}</strong>
            </h1>




            <div className={`flex justify-between space-x-4  items-center `}>
                <BackToLandingButton />
                <ExploreEverythingButton />
            </div>

        </div>
    );
};

export default SearchTitle;